import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Schoolpicnicbusrentalserviceinpune() {



  const cardData = {
"keyword": "School Picnic Bus Rental Services in Pune",

"headingDescription":
  "Aaradhya Travels offers dependable School Picnic Bus Rental Services in Pune for school trips, educational tours, picnic outings, college excursions, industrial visits, and student group transportation requirements. Our fleet includes comfortable mini buses, luxury buses, and tempo travellers equipped with air-conditioning, pushback seats, spacious interiors, safety features, and experienced drivers familiar with Pune tourist attractions and highway routes. We ensure safe, comfortable, and punctual transportation with doorstep pickup for students, teachers, and school staff across Pune and nearby destinations.",

"topPlaces": [
{
"title": "Imagicaa Theme Park",
"description":
"Imagicaa is a large theme park near Mumbai offering rides, entertainment zones, and water parks. It is a popular destination for school trips, corporate outings, and family group tours."
},
{
"title": "Karjat",
"description":
"Karjat is a scenic green valley near Mumbai known for waterfalls, rivers, resorts, and adventure activities. It is widely chosen for weekend group trips and corporate outings."
},
{
"title": "Khopoli",
"description":
"Khopoli is known for industrial areas, waterfalls nearby, and proximity to Imagicaa theme park. It is a convenient stopover destination for group travel between Pune and Mumbai."
},
  {
"title": "Mumbai",
"description":
"Mumbai is the financial capital of India known for Marine Drive, Gateway of India, Juhu Beach, Bollywood, shopping streets, and vibrant city life. It is one of the most popular group travel destinations from Pune for corporate tours, shopping trips, and leisure outings."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station near Mumbai known for toy train rides, viewpoints, dense greenery, and cool weather. It is a peaceful weekend getaway for families and group travelers from Pune and Mumbai."
},
{
"title": "Alibaug",
"description":
"Alibaug is a coastal beach destination near Mumbai known for clean beaches, sea forts, water sports, and relaxed seaside atmosphere. It is a popular group tour destination for short trips from Pune."
},
{
"title": "Lonavala",
"description":
"Lonavala is a famous hill station near Mumbai and Pune known for waterfalls, caves, green valleys, and monsoon beauty. It is a highly visited weekend destination for group bus and Tempo Traveller trips."
},
{
"title": "Khandala",
"description":
"Khandala is known for scenic valleys, misty hills, and natural viewpoints. It is a short and relaxing getaway destination popular among families and group travelers from Mumbai and Pune."
},
{
"title": "Navi Mumbai",
"description":
"Navi Mumbai is a planned city known for clean infrastructure, parks, malls, and business hubs. It is commonly visited for corporate group travel, events, and city tours."
},
{
"title": "Elephanta Caves",
"description":
"Elephanta Caves are UNESCO World Heritage rock-cut caves located on an island near Mumbai known for ancient sculptures and historical significance. It is a popular heritage group tour destination."
},

],



services: [
  {
    name: "School Picnic Bus Pune",
    description: "School picnic bus Pune service provides safe and comfortable transportation for student outings, educational tours, school picnics, and group travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for students, teachers, and school staff. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from schools, homes, and educational institutions across Pune. Flexible booking options allow convenient school picnic bus reservations."
  },
  {
    name: "School Trip Bus Hire Pune",
    description: "School trip bus hire Pune service offers dependable transportation for educational tours, sightseeing journeys, academic visits, and student group travel. Comfortable seating and luggage space ensure smooth journeys suitable for local and outstation school trips. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient school trip bus hire reservations."
  },
  {
    name: "Educational Trip Bus Pune",
    description: "Educational trip bus Pune service provides reliable transportation for academic tours, industrial visits, science exhibitions, historical tours, and educational outings. Spacious seating ensures comfortable journeys suitable for students, faculty members, and educational groups. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from schools, colleges, and institutes across Pune. Flexible booking options allow convenient educational trip bus reservations."
  },
  {
    name: "School AC Bus Pune",
    description: "School AC bus Pune service offers premium air-conditioned transportation for school picnics, educational tours, student outings, and academic group travel. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure dependable transportation and safe driving services throughout the journey. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient AC school bus reservations."
  },
  {
    name: "Non AC School Bus Pune",
    description: "Non AC school bus Pune service provides affordable transportation for school trips, educational tours, picnic outings, and student group travel requirements. Spacious seating ensures comfortable journeys suitable for budget-friendly educational transportation. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient non AC school bus reservations."
  },
  {
    name: "40 Seater School Bus Pune",
    description: "40 seater school bus Pune service provides spacious transportation for school tours, educational trips, picnic outings, and student group travel. Comfortable seating and luggage space ensure smooth journeys suitable for large school groups and faculty members. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient 40 seater school bus reservations."
  },
  {
    name: "50 Seater School Bus Pune",
    description: "50 seater school bus Pune service offers reliable transportation for school picnics, academic tours, student outings, and large educational group travel. Spacious interiors and comfortable seating ensure pleasant journeys suitable for students, teachers, and educational staff. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient 50 seater school bus reservations."
  },
  {
    name: "School Outing Bus Pune",
    description: "School outing bus Pune service provides dependable transportation for school excursions, educational outings, sports events, and student travel requirements. Comfortable seating and smooth travel ensure pleasant journeys suitable for local and outstation school trips. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from schools, educational institutes, and campuses across Pune. Flexible booking options allow convenient school outing bus reservations."
  },
  {
    name: "Pune to Mahabaleshwar School Bus",
    description: "Pune to Mahabaleshwar school bus service offers comfortable transportation for educational tours, hill station trips, school picnics, and student group travel. Spacious seating and smooth ghat road travel ensure enjoyable journeys suitable for students and faculty groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient Mahabaleshwar school bus reservations."
  },
  {
    name: "Pune to Lonavala School Bus",
    description: "Pune to Lonavala school bus service provides reliable transportation for educational tours, sightseeing trips, school outings, and student travel requirements. Comfortable seating and smooth expressway travel ensure pleasant journeys suitable for school groups and faculty members. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from schools and educational campuses across Pune. Flexible booking options allow convenient Lonavala school bus reservations."
  },
  {
    name: "Pune to Alibaug School Bus",
    description: "Pune to Alibaug school bus service provides spacious transportation for beach trips, educational tours, sightseeing journeys, and school outings. Comfortable seating and luggage space ensure smooth journeys suitable for students and faculty travel requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and institutions across Pune. Flexible booking options allow convenient Alibaug school bus reservations."
  },
  {
    name: "School Picnic Outstation Bus Pune",
    description: "School picnic outstation bus Pune service provides dependable long-distance transportation for educational tours, sightseeing trips, academic outings, and student group travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient outstation school picnic bus reservations."
  },
  {
    name: "Safe School Transport Pune",
    description: "Safe school transport Pune service provides secure and dependable transportation for school students, educational tours, picnic outings, and academic travel requirements. Spacious seating and smooth travel ensure comfortable journeys suitable for students and school staff. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from schools, homes, and educational institutions across Pune. Flexible booking options allow convenient safe school transport reservations."
  },
  {
    name: "School Group Travel Pune",
    description: "School group travel Pune service provides spacious transportation for educational tours, student outings, academic events, and school picnic travel requirements. Comfortable seating ensures pleasant journeys suitable for large school groups and faculty members. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient school group travel reservations."
  },
  {
    name: "School Bus Booking Pune",
    description: "School bus booking Pune service offers reliable transportation for school tours, educational outings, academic trips, and student travel requirements. Spacious seating and luggage space ensure smooth journeys suitable for local and outstation educational transportation. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from schools, homes, and colleges across Pune. Flexible booking options allow convenient school bus booking reservations."
  },
  {
    name: "School Tour Bus Pune",
    description: "School tour bus Pune service provides dependable transportation for sightseeing tours, educational visits, historical tours, and student travel requirements. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for students and teaching staff. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient school tour bus reservations."
  },
  {
    name: "School Field Trip Bus Pune",
    description: "School field trip bus Pune service offers comfortable transportation for industrial visits, educational tours, nature camps, and student learning journeys. Spacious seating ensures smooth travel suitable for school groups and faculty members. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and institutes across Pune. Flexible booking options allow convenient school field trip bus reservations."
  },
  {
    name: "School Excursion Bus Pune",
    description: "School excursion bus Pune service provides dependable transportation for educational outings, sightseeing tours, museum visits, and student travel requirements. Comfortable seating and smooth travel ensure pleasant journeys suitable for school groups and academic staff. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient school excursion bus reservations."
  },
  {
    name: "School Transport Service Pune",
    description: "School transport service Pune provides reliable transportation for school students, educational tours, academic events, and daily or occasional school travel requirements. Spacious seating and smooth journeys ensure comfortable travel suitable for students and faculty groups. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from schools, homes, and educational campuses across Pune. Flexible booking options allow convenient school transport service reservations."
  },
  {
    name: "School Picnic Package Pune",
    description: "School picnic package Pune service offers complete transportation solutions for school outings, educational tours, sightseeing trips, and student travel requirements. Comfortable seating and organized travel arrangements ensure smooth journeys suitable for school groups and academic staff. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient school picnic package reservations."
  },
  {
    name: "Affordable School Bus Pune",
    description: "Affordable school bus Pune service provides economical transportation for educational tours, school outings, picnic journeys, and student group travel. Spacious seating and luggage space ensure comfortable travel experiences suitable for budget-friendly educational transportation requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient affordable school bus reservations."
  },
  {
    name: "Luxury School Bus Pune",
    description: "Luxury school bus Pune service provides premium transportation with modern interiors and comfortable seating for educational tours, school outings, academic travel, and student group journeys. Smooth travel and spacious interiors ensure pleasant journeys suitable for students and faculty groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and institutions across Pune. Flexible booking options allow convenient luxury school bus reservations."
  },
  {
    name: "School Event Bus Pune",
    description: "School event bus Pune service provides dependable transportation for annual functions, sports events, competitions, educational fairs, and student travel requirements. Spacious seating ensures smooth journeys suitable for local and outstation school event transportation. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient school event bus reservations."
  },
  {
    name: "Pune School Travel Agency Bus",
    description: "Pune school travel agency bus service offers organized transportation for educational tours, sightseeing trips, school picnics, and academic travel requirements. Comfortable seating and smooth travel ensure pleasant journeys suitable for students, teachers, and faculty groups. Professional drivers ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient school travel agency bus reservations."
  },
  {
    name: "School Charter Bus Pune",
    description: "School charter bus Pune service provides spacious transportation for educational tours, student group travel, academic outings, and school picnic requirements. Comfortable seating and luggage space ensure smooth journeys suitable for medium and large school groups. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from schools, colleges, and educational institutions across Pune. Flexible booking options allow convenient school charter bus reservations."
  }
],

tableData: [
  ["School Picnic Bus Pune", "School Trip Bus Hire Pune"],
  ["Educational Trip Bus Pune", "School AC Bus Pune"],
  ["Non AC School Bus Pune", "40 Seater School Bus Pune"],
  ["50 Seater School Bus Pune", "School Outing Bus Pune"],
  ["Pune to Mahabaleshwar School Bus", "Pune to Lonavala School Bus"],
  ["Pune to Alibaug School Bus", "School Picnic Outstation Bus Pune"],
  ["Safe School Transport Pune", "School Group Travel Pune"],
  ["School Bus Booking Pune", "School Tour Bus Pune"],
  ["School Field Trip Bus Pune", "School Excursion Bus Pune"],
  ["School Transport Service Pune", "School Picnic Package Pune"],
  ["Affordable School Bus Pune", "Luxury School Bus Pune"],
  ["School Event Bus Pune", "Pune School Travel Agency Bus"],
  ["School Charter Bus Pune", "School Group Travel Pune"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable School Picnic Bus Rental Services in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable school picnic bus rental services in Pune with comfortable buses, professional drivers, and safe travel arrangements for school trips, educational tours, and student outings."
      },
      {
        WhyChooseheading: "Affordable School Trip Bus Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable school picnic bus rental packages in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "Safe & Secure Student Transportation",
        WhyChoosedescription: "Our school picnic bus rental service focuses on student safety with experienced drivers, well-maintained buses, smooth travel management, and timely pickup and drop services."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC School Buses",
        WhyChoosedescription: "All buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for comfortable student and teacher travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day School Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized school picnic travel packages including one-day educational tours, camping trips, industrial visits, sightseeing tours, and multi-day excursions."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from 14 seater, 17 seater, 20 seater, 25 seater, 32 seater, 35 seater, 40 seater, and 50 seater buses suitable for school groups and student travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune Schools",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from schools located in Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Pimpri Chinchwad, Kothrud, Camp, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for School Tours",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth coordination, and timely transportation for school picnics, educational tours, sports events, and student group travel."
      }
    ]
  };

  const faqData = [
    { question: "What are school picnic bus rental services in Pune?", answer: "School picnic bus rental services in Pune provide comfortable and safe transportation for school trips, educational tours, student outings, and group travel." },
    { question: "Do you provide buses for school trips and educational tours?", answer: "Yes, Aaradhya Travels provides buses for school picnics, educational tours, industrial visits, sports events, and student excursions." },
    { question: "Which bus seating options are available for school groups?", answer: "Aaradhya Travels offers 14 seater, 17 seater, 20 seater, 25 seater, 32 seater, 35 seater, 40 seater, and 50 seater buses for school transportation." },
    { question: "Are AC and Non-AC school buses available?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC buses for comfortable and budget-friendly school travel." },
    { question: "Can I book buses for outstation school trips from Pune?", answer: "Yes, customers can book buses for outstation school tours, hill station trips, camping tours, and educational travel from Pune." },
    { question: "Are drivers experienced for school transportation?", answer: "Yes, Aaradhya Travels provides experienced and professional drivers for safe school picnic and student travel services." },
    { question: "Can I book school picnic buses online?", answer: "Yes, customers can easily book school picnic bus rental services online or through phone booking." },
    { question: "Do you provide pickup from schools across Pune?", answer: "Yes, Aaradhya Travels provides pickup and drop services from schools across Pune and Pimpri Chinchwad areas." },
    { question: "Are school bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for school picnic bus rental service?", answer: "Yes, advance booking is available and recommended during school picnic seasons, holidays, and annual educational tour periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Abhijit More",
    feedback:
      "The school picnic bus rental service in Pune by Aaradhya Travels was very well organized. The bus was clean and safe, and the students enjoyed a comfortable and cheerful journey throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Deshmukh",
    feedback:
      "Aaradhya Travels handled our school picnic transport in Pune very professionally. The bus was well-maintained, punctual, and ensured a smooth and safe travel experience for all the children.",
    rating: 5
  }
];
  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "School Picnic Bus Rental Services in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/school-picnic-bus-pune.jpg",
  "description": "Book School Picnic Bus Rental Services in Pune with Aaradhya Travels for school trips, educational tours, and picnic outings. Available AC and non-AC buses in 40 and 50 seater options for safe and comfortable travel to destinations like Lonavala, Mahabaleshwar, and Alibaug.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "11120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/school-picnic-bus-rental-services-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>
    School Picnic Bus Rental Services in Pune | Safe School Trips | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire School Picnic Bus Rental Services in Pune with Aaradhya Travels. Safe AC and non-AC 40 and 50 seater buses for school trips, educational tours, and picnic outings to Lonavala, Mahabaleshwar, Alibaug, and more."
  />

  <meta
    name="keywords"
    content="School picnic bus Pune, school trip bus hire Pune, educational trip bus Pune, school AC bus Pune, non AC school bus Pune, 40 seater school bus Pune, 50 seater school bus Pune, school outing bus Pune, Pune to Mahabaleshwar school bus, Pune to Lonavala school bus, Pune to Alibaug school bus, school picnic outstation bus"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Schoolpicnicbusrentalserviceinpune ;